var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","text-align":"left"},attrs:{"id":"app"}},[_c('Designer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }